(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ModalityDialogController', ModalityDialogController);

    ModalityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Modality'];

    function ModalityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Modality) {
        var vm = this;

        vm.modality = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.modality.id !== null) {
                Modality.update(vm.modality, onSaveSuccess, onSaveError);
            } else {
                Modality.save(vm.modality, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:modalityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
